/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q2Inputs */

const en_consult_q2 = /** @type {(inputs: Consult_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's your budget?`)
};

const id_consult_q2 = /** @type {(inputs: Consult_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa budget-nya?`)
};

/**
* | output |
* | --- |
* | "What's your budget?" |
*
* @param {Consult_Q2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q2 = /** @type {((inputs?: Consult_Q2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q2(inputs)
	return en_consult_q2(inputs)
});